module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"columns":{"options":"Options","desc":"Description","max_input_count":"Max Input #","licensed_options":"Licensed Options","hardware_capable":"Hardware Capable"}},"zh-CHS":{"columns":{"options":"选项","desc":"描述","max_input_count":"扩展输入通道","licensed_options":"选项","hardware_capable":"硬件兼容性"}}}')
  delete Component.options._Ctor
}
